import { useSelector } from 'react-redux'

import { EditDeviceModal, useDeviceModals } from '@/features/device-crud'
import { DeviceType } from '@/graphql/generated/schemas'
import { selectDevice } from '@/redux/ui/uiSlice'

import { ACDeviceDrawer } from './ACDeviceDrawer'
import { CameraDeviceDrawer } from './CameraDeviceDrawer'

interface IProps {
  isOpen: boolean
  onClose: () => void
}

export const DeviceDrawer = ({ isOpen, onClose }: IProps) => {
  const { id, type } = useSelector(selectDevice)
  const { openEditDevice, onEditDeviceClose, isEditDeviceOpen, deviceData } =
    useDeviceModals()

  const renderDrawer = () => {
    switch (type) {
      case DeviceType.Camera:
        return (
          <CameraDeviceDrawer
            defaultIndex={0}
            deviceId={id}
            isOpen={isOpen}
            onClose={onClose}
            onEditClick={openEditDevice}
          />
        )
      case DeviceType.Door:
        return (
          <ACDeviceDrawer
            defaultIndex={0}
            deviceId={id}
            isOpen={isOpen}
            onClose={onClose}
            onEditClick={openEditDevice}
          />
        )
      default:
        return null
    }
  }

  return (
    <>
      {renderDrawer()}
      {isEditDeviceOpen && (
        <EditDeviceModal
          deviceData={deviceData}
          isOpen={isEditDeviceOpen}
          onClose={onEditDeviceClose}
        />
      )}
    </>
  )
}
